module.exports = __webpack_public_path__ + "img/head.146b5767.png";